import { Pipe, PipeTransform } from '@angular/core';

export type OtpDeliveryMethodStatus = 'ENROLLED' | 'NOT_ENROLLED' | 'UNKNOWN';
export const OtpDeliveryMethodStatus = {
    Enrolled: 'ENROLLED' as OtpDeliveryMethodStatus,
    NotEnrolled: 'NOT_ENROLLED' as OtpDeliveryMethodStatus,
    Unknown: 'UNKNOWN' as OtpDeliveryMethodStatus,
};

export interface OtpDeliveryMethodOption {
  enabled: boolean;
  show_login_popup: boolean;
  status: OtpDeliveryMethodStatus;
}

export interface OtpDeliveryMethods {
  SMS: OtpDeliveryMethodOption;
  APP: OtpDeliveryMethodOption;
}

export class Identity {

  public pk!: string;
  public type!: number;
  public status!: string;
  public role!: string;
  public level?: number;
  public issuer?: string;
  public expire_date?: Date;
  public release_date?: Date;
  public password_expire_date?: Date;
  public otp_delivery_methods?: OtpDeliveryMethods;

  constructor(init?: Partial<Identity>) {
    Object.assign(this, init);
  }

  public isManagement(): boolean {
    return (this.type === 4 && this.role === 'MANAGEMENT');
  }

  public isGovernment(): boolean {
    return (this.type === 4 && this.role === 'GOVERNMENT');
  }

  public isEmployee(): boolean {
    return (this.type === 4 && this.role === 'EMPLOYEE');
  }

}

export const identityTypeMap = new Map<number, string>([
  [1, 'persona fisica'],
  [2, 'persona giuridica'],
  [3, 'persona fisica uso professionale'],
  [4, 'persona giuridica uso professionale'],
]);

export const identityStatusDisplayMap = new Map([
  ['CREATED', 'Identità in attesa di approvazione'],
  ['APPROVED', 'Identità in attesa di emissione'],
  ['ISSUING', 'Identità in stato di emissione'],
  ['ISSUED', 'Identità Attiva'],
  ['HOLD', 'Identità Sospesa'],
  ['EXPIRED', 'Identità Scaduta'],
  ['REVOKED', 'Identità Revocata']
]);

export const spid4RoleMap = new Map<string, string>([
  ['GOVERNMENT', 'persona giuridica uso professionale abilitata utenza di governo'],
  ['MANAGEMENT', 'persona giuridica uso professionale abilitata utenza di gestione'],
  ['EMPLOYEE', 'persona giuridica uso professionale abilitata utenza dipendente/Collaboratore'],
]);


@Pipe({
  name: 'getIdentityDisplayStatusPipe',
  pure: true
})
export class GetIdentityDisplayStatusPipe implements PipeTransform {

  transform(status: string, args?: any): any {
    return this.getIdentityDisplayStatusPipe(status);
  }
  getIdentityDisplayStatusPipe(status: string): string {
    return identityStatusDisplayMap.get(status);
  }
}

@Pipe({
  name: 'getIdentityTypeDisplayPipe',
  pure: true
})
export class GetIdentityTypeDisplayPipe implements PipeTransform {

  transform(identity: Identity, args?: any): any {
    return this.getIdentityTypeDisplayPipe(identity);
  }

  getIdentityTypeDisplayPipe(identity: Identity): string {
    const type = identity.type;
    if (type === 4) {
      return spid4RoleMap.get(identity.role);
    }
    return identityTypeMap.get(type);
  }
}
